import katex from "katex";

/**
 * Converts a string in the format "numerator/denominator" to a KaTeX fraction
 * @param value - The fraction string to convert (e.g. "1/2")
 * @returns The KaTeX rendered fraction HTML or the original string if conversion fails
 */
export const convertToFraction = (value: string) => {
  // 숫자/숫자 형식인지 확인 (음수 포함)
  const fractionRegex = /^(-?)(\d+)\/(\d+)$/;
  const match = value.match(fractionRegex);

  if (match) {
    const [_, sign, numerator, denominator] = match;
    try {
      // 음수인 경우 - 기호를 분수 앞에 배치
      const fractionString = sign 
        ? `-\\frac{${numerator}}{${denominator}}`
        : `\\frac{${numerator}}{${denominator}}`;
      
      return katex.renderToString(fractionString, {
        throwOnError: false,
        displayMode: false,
      });
    } catch (e) {
      return value;
    }
  }
  return value;
};
